export default __webpack_public_path__ + "static/media/arrows-up-down.98b1625d.svg";